module.exports = __webpack_public_path__ + "img/mygroups-active.07adc14b.svg";